import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export default function AuthConfirm() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const tokenHash = searchParams.get("token_hash");
    const type = searchParams.get("type") as
      | "signup"
      | "recovery"
      | "invite"
      | "magiclink"
      | "email_change"
      | null;

    if (!tokenHash || !type) {
      setError("Ogiltig bekräftelselänk");
      return;
    }

    const verify = async () => {
      const { error: verifyError } = await supabase.auth.verifyOtp({
        token_hash: tokenHash,
        type,
      });

      if (verifyError) {
        console.error("Verify OTP error:", verifyError);
        setError("Länken har gått ut eller är ogiltig. Försök igen.");
        return;
      }

      // Redirect based on type
      switch (type) {
        case "recovery":
          navigate("/auth/reset-password");
          break;
        case "signup":
        case "magiclink":
        case "invite":
          navigate("/");
          break;
        case "email_change":
          navigate("/profile");
          break;
        default:
          navigate("/");
      }
    };

    verify();
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center space-y-4 max-w-sm px-6">
          <div className="text-4xl">❌</div>
          <h1 className="text-xl font-semibold">Något gick fel</h1>
          <p className="text-muted-foreground">{error}</p>
          <a
            href="/auth"
            className="inline-block text-primary hover:underline text-sm"
          >
            Tillbaka till inloggning
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center space-y-4">
        <div className="animate-spin h-8 w-8 border-4 border-primary border-t-transparent rounded-full mx-auto" />
        <p className="text-muted-foreground">Bekräftar...</p>
      </div>
    </div>
  );
}
